"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _task = _interopRequireDefault(require("_c/Flowable/nodePanel/task"));
var _startEnd = _interopRequireDefault(require("_c/Flowable/nodePanel/startEnd"));
var _process = _interopRequireDefault(require("_c/Flowable/nodePanel/process"));
var _sequenceFlow = _interopRequireDefault(require("_c/Flowable/nodePanel/sequenceFlow"));
var _gateway = _interopRequireDefault(require("_c/Flowable/nodePanel/gateway"));
var _zh = require("_l/flowable/lang/zh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PropertyPanel',
  components: {
    processPanel: _process.default,
    taskPanel: _task.default,
    startEndPanel: _startEnd.default,
    sequenceFlowPanel: _sequenceFlow.default,
    gatewayPanel: _gateway.default
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    categorys: {
      type: Array,
      required: true
    },
    modeler: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      element: null,
      form: {
        id: '',
        name: '',
        color: null
      },
      roles: [{
        value: 'manager',
        label: '经理'
      }, {
        value: 'personnel',
        label: '人事'
      }, {
        value: 'charge',
        label: '主管'
      }]
    };
  },
  computed: {
    getComponent: function getComponent() {
      var type = this.element.type;
      if (['bpmn:IntermediateThrowEvent', 'bpmn:StartEvent', 'bpmn:EndEvent'].includes(type)) {
        return 'startEndPanel';
      }
      if (['bpmn:UserTask', 'bpmn:Task', 'bpmn:SendTask', 'bpmn:ReceiveTask', 'bpmn:ManualTask', 'bpmn:BusinessRuleTask', 'bpmn:ServiceTask', 'bpmn:ScriptTask'
      // 'bpmn:CallActivity',
      // 'bpmn:SubProcess'
      ].includes(type)) {
        return 'taskPanel';
      }
      if (type === 'bpmn:SequenceFlow') {
        return 'sequenceFlowPanel';
      }
      if (['bpmn:InclusiveGateway', 'bpmn:ExclusiveGateway', 'bpmn:ParallelGateway', 'bpmn:EventBasedGateway'].includes(type)) {
        return 'gatewayPanel';
      }
      if (type === 'bpmn:Process') {
        return 'processPanel';
      }
      return null;
    },
    nodeName: function nodeName() {
      if (this.element) {
        var bizObj = this.element.businessObject;
        var type = bizObj.eventDefinitions ? bizObj.eventDefinitions[0].$type : bizObj.$type;
        return _zh.NodeName[type] || type;
      }
      return '';
    }
  },
  mounted: function mounted() {
    this.handleModeler();
  },
  methods: {
    handleModeler: function handleModeler() {
      var _this = this;
      this.modeler.on('root.added', function (e) {
        if (e.element.type === 'bpmn:Process') {
          _this.element = null;
          _this.$nextTick().then(function () {
            _this.element = e.element;
          });
        }
      });
      this.modeler.on('element.click', function (e) {
        var element = e.element;
        // console.log(element)
        if (element.type === 'bpmn:Process') {
          _this.element = element;
        }
      });
      this.modeler.on('selection.changed', function (e) {
        // hack 同类型面板不刷新
        _this.element = null;
        var element = e.newSelection[0];
        if (element) {
          _this.$nextTick().then(function () {
            _this.element = element;
          });
        }
      });
    }
  }
};